import React, { useState } from 'react';
import { Text } from 'components/typography';
import { useModal } from 'store/modals';
import { Icon, Modal, Segment } from 'semantic-ui-react';
import { Button } from 'components/form-elements/buttons/Button';
import { ShouldRender } from '../../ShouldRender';
import styles from './styles.module.scss';

export const ConfirmationModal = ({ title, content, onConfirm, onCancel, type, confirmLabel = 'yes', cancelLabel = 'no' }) => {
  const { closeModal } = useModal();
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
    } finally {
      setIsLoading(false);
      closeModal();
    }
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    closeModal();
  };

  return (
    <Modal
      size="small"
      centered
      dimmer="inverted"
      open
    >
      <Modal.Header textAlign="center">
        <ShouldRender condition={type === 'warning'}>
          <Segment
            textAlign="center"
            basic
          >
            <Icon
              name="warning circle"
              color="yellow"
              size="big"
              textAlign="center"
            />
          </Segment>
        </ShouldRender>
        <Text
          center
          size={20}
        >
          {title}
        </Text>
      </Modal.Header>

      <Modal.Content>
        <Text
          center
          size={18}
        >
          {content}
        </Text>
      </Modal.Content>
      <Modal.Actions>
        <div className={styles.actions}>
          <Button
            intl={cancelLabel || 'no'}
            onClick={handleCancel}
            disabled={isLoading}
          />

          <Button
            intl={confirmLabel || 'yes'}
            onClick={handleConfirm}
            loading={isLoading}
            disabled={isLoading}
          />
        </div>
      </Modal.Actions>
    </Modal>
  ); 
};
